function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 107.785 20.104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-18 -361.941)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    },
    transform: "translate(-15.082 366.326)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    },
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M398.43,308.866l1.766-2.115a6.232,6.232,0,0,0,4.056,1.65c1.223,0,1.96-.485,1.96-1.32,0-.757-.466-1.145-2.736-1.727-2.736-.7-4.5-1.456-4.5-4.192,0-2.465,1.98-4.095,4.755-4.095a7.864,7.864,0,0,1,5.046,1.727l-1.553,2.251a6.373,6.373,0,0,0-3.532-1.339c-1.145,0-1.746.524-1.746,1.223,0,.893.582,1.184,2.93,1.785,2.756.718,4.308,1.708,4.308,4.114,0,2.7-2.057,4.211-4.987,4.211A8.644,8.644,0,0,1,398.43,308.866Z",
    transform: "translate(-355.908 -295.359)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M451.067,300.6h-4.134v-2.756h11.256V300.6h-4.134V311.43h-2.988Z",
    transform: "translate(-392.322 -295.943)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M496.526,303.936a7.222,7.222,0,1,1,7.2,7.025A7.025,7.025,0,0,1,496.526,303.936Zm11.314,0a4.127,4.127,0,0,0-4.114-4.27,4.073,4.073,0,0,0-4.076,4.27,4.127,4.127,0,0,0,4.114,4.27A4.073,4.073,0,0,0,507.84,303.936Z",
    transform: "translate(-429.554 -295.242)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M565.116,297.845h6.21a5.415,5.415,0,0,1,3.959,1.378,4.3,4.3,0,0,1,1.164,3.144,4.218,4.218,0,0,1-2.911,4.211l3.319,4.852h-3.493l-2.95-4.347H568.1v4.347h-2.989Zm6.016,6.6c1.456,0,2.29-.776,2.29-1.96,0-1.281-.893-1.941-2.348-1.941H568.1v3.9Z",
    transform: "translate(-481.048 -295.943)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "M619.073,306.074l-5.22-8.229h3.493l3.241,5.453,3.3-5.453h3.4l-5.22,8.17v5.415h-2.989Z",
    transform: "translate(-517.637 -295.943)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1aa9b4"
    },
    d: "M675.2,297.845h3.221l3.571,5.744,3.571-5.744h3.221V311.43h-2.969v-8.869l-3.823,5.8h-.078l-3.784-5.744v8.811H675.2Z",
    transform: "translate(-563.695 -295.943)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1aa9b4"
    },
    d: "M742.779,297.845h5.3c4.27,0,7.219,2.93,7.219,6.792,0,3.823-2.95,6.792-7.219,6.792h-5.3Zm5.3,10.887a4.095,4.095,0,1,0,0-8.19h-2.309v8.19Z",
    transform: "translate(-614.429 -295.943)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(18 361.941)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1aa9b4"
    },
    d: "M179.513,278.79H176v-2.678h3.513v-3.493h2.756v3.493h3.513v2.678h-3.513v3.493h-2.756Z",
    transform: "translate(-176 -272.619)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.5eb3c22c7d3f0e695a6f0a9d2cd4e268.svg";
export { ForwardRef as ReactComponent };